
export function initEnums(hstRtcEngine) {
  /**
   * 导出的媒体类型
   */
  hstRtcEngine.prototype.MediaType = {
    SCREEN_SHARE: 0,
    AUDIO: 1,
    VIDEO: 2,
    TRANSPARENT_DATA: 3,
    WHITE_BOARD: 4
  };

  /**
   * 导出的在线状态
   */
  hstRtcEngine.prototype.OnlineType = {
    OFFLINE: 0,
    ONLINE: 1
  };

  /**
   * 导出白板显示模式
   */
  hstRtcEngine.prototype.DisplayMode = {
    DBWZ: 1,  // 等比完整
    DBSY: 2,  // 等比适应
    DBSF: 3   // 等比缩放
  }
}
